import z from 'zod';
import { languageSchema } from '@app/schemas/language';

export const imageSchema = z.object({
  uri: z.string().nonempty({ message: 'Image cannot be empty' }),
  width: z.number().optional(),
  height: z.number().optional(),
});

z.globalRegistry.add(imageSchema, { id: 'image' });

export type ImageSchema = z.infer<typeof imageSchema>;

export const imageTranslatableSchema = z.object({
  fallback: languageSchema,
  translations: z.record(languageSchema, imageSchema),
});

z.globalRegistry.add(imageTranslatableSchema, { id: 'image-translatable' });

export type ImageTranslatableSchema = z.infer<typeof imageTranslatableSchema>;

export const imageActivatableTranslatableSchema = z.object({
  normal: imageTranslatableSchema,
  active: imageTranslatableSchema.optional(),
});

z.globalRegistry.add(imageActivatableTranslatableSchema, { id: 'image-activatable-translatable' });

export type ImageActivatableTranslatableSchema = z.infer<typeof imageActivatableTranslatableSchema>;
